<template>
  <footer id="app-footer" class="app-footer-styled">
    <div class="container footer-container-styled">
      <div class="footer-column footer-logo-social-column">
        <!-- 直接使用这张包含所有元素的图片 -->
        <img
          src="@/assets/icons/bt.png"
          alt="UAMAX Logo and Contact Icons"
          class="footer-brand-image"
        />
      </div>

      <div class="footer-column footer-office-column">
        <h4>{{ $t('footer.ourOffice.title') }}</h4>
        <p>{{ $t('footer.ourOffice.addressLine1') }}</p>
        <p>{{ $t('footer.ourOffice.addressLine2') }}</p>
        <p>{{ $t('footer.ourOffice.addressLine3') }}</p>
      </div>

      <div class="footer-column footer-contact-column">
        <h4>{{ $t('footer.contactUs.title') }}</h4>
        <p>
          <span class="contact-label">{{ $t('footer.contactUs.emailLabel') }}:</span>
          <a :href="'mailto:' + $t('footer.contactUs.emailValue')">{{ $t('footer.contactUs.emailValue') }}</a>
        </p>
        <p>
          <span class="contact-label">{{ $t('footer.contactUs.telegramLabel') }}:</span>
          <a :href="'https://t.me/' + $t('footer.contactUs.telegramValue').replace('@','')" target="_blank" rel="noopener noreferrer">{{ $t('footer.contactUs.telegramValue') }}</a>
        </p>
        <p>
          <span class="contact-label">{{ $t('footer.contactUs.whatsappLabel') }}:</span>
          <a :href="'https://wa.me/' + $t('footer.contactUs.whatsappValue').replace('+', '')" target="_blank" rel="noopener noreferrer">{{ $t('footer.contactUs.whatsappValue') }}</a>
        </p>
        <p>
          <span class="contact-label">{{ $t('footer.contactUs.teamsLabel') }}:</span>
          <a :href="'mailto:' + $t('footer.contactUs.teamsValue')">{{ $t('footer.contactUs.teamsValue') }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooterStyled',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer-styled {
  background-color: #3B5998; /* 请根据图片精确调整此蓝色值 */
  color: #ffffff;
  padding: 40px 0;
  font-family: Arial, sans-serif;
}

.footer-container-styled {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  gap: 30px;
  align-items: flex-start;
}

.footer-column {
  padding-top: 10px;
}

.footer-logo-social-column {
  display: flex; /* 确保图片可以被约束大小 */
  align-items: flex-start; /* 或者 center 如果图片本身有留白 */
  padding-top: 0;
}

.footer-brand-image { /* 新的类名，用于这张包含所有元素的图片 */
  width: auto; /* 宽度自适应 */
  height: auto; /* 高度自适应 */
  max-width: 200px; /* 设置一个最大宽度，根据你的图片和设计调整 */
  max-height: 100px; /* 设置一个最大高度，防止图片过大 */
  object-fit: contain; /* 保持图片比例 */
}

/* 移除了 .footer-logo-styled 和 .footer-social-icons-styled 的特定样式 */

.footer-office-column h4,
.footer-contact-column h4 {
  font-size: 1.1rem;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 15px;
}

.footer-office-column p,
.footer-contact-column p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 8px;
}
.footer-office-column p:last-child,
.footer-contact-column p:last-child {
  margin-bottom: 0;
}

.footer-contact-column a {
  color: #ffffff;
  text-decoration: none;
}
.footer-contact-column a:hover {
  text-decoration: underline;
}

.contact-label {
  font-weight: normal;
}

@media (max-width: 992px) {
  .footer-container-styled {
    grid-template-columns: auto 1fr;
    gap: 20px 40px;
  }
  .footer-logo-social-column {
    grid-column: 1 / -1;
    justify-content: center; /* 居中整个品牌图片 */
    margin-bottom: 20px;
  }
  .footer-office-column,
  .footer-contact-column {
    padding-top: 0;
  }
}

@media (max-width: 600px) {
  .footer-container-styled {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .footer-logo-social-column,
  .footer-office-column,
  .footer-contact-column {
    align-items: center;
    margin-bottom: 25px;
  }
   .footer-logo-social-column {
     margin-bottom: 15px;
  }
  .footer-contact-column:last-child {
    margin-bottom: 0;
  }
}
</style>